import { buttonContainer, avatar } from './UserProfileButton.css';

export interface UserProfileButtonBaseProps {
  /**
   * User data
   */
  user: {
    name: string;
    avatar?: string;
  };

  /**
   * Callback when the button is clicked
   */
  onClick?: () => void;

  /**
   * Additional CSS class name
   */
  className?: string;

  /**
   * ID for the button element
   */
  id?: string;
}

/**
 * UserProfileButtonBase component that displays a user avatar button without a popover
 * This is useful when you want to implement your own menu/popover
 */
export function UserProfileButtonBase({ user, onClick, className, id }: UserProfileButtonBaseProps) {
  return (
    <div className={`${buttonContainer} ${className || ''}`}>
      <button aria-label="User profile" className={avatar} id={id} onClick={onClick}>
        {user.avatar ? (
          <img alt={user.name} src={user.avatar} />
        ) : (
          <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
              fill="currentColor"
            />
          </svg>
        )}
      </button>
    </div>
  );
}
